import React, {FC} from 'react';
import './styles.scss';

const RadioButton: FC<any> = ({enabled, label, onChange, canDisable, disabled, className}) => {
  return (
    <div
      className={`vk-custom-radio noselect ${className ? className : ''}`}
      onClick={() => {
        onChange && !disabled && onChange(canDisable ? !enabled : label === 'Enabled' ? true : false);
      }}
    >
      <div className={`outer-circle ${disabled ? 'disabled' : ''}`}>
        {enabled && <div className="inner-circle"></div>}
      </div>
      <span className="noselect">{label}</span>
    </div>
  );
};

export default RadioButton;
